import { Alert, AlertProps, Stack, Text } from '@mantine/core';
import { ExtAttachmentType } from 'api/extForms/types/postFormsTypes';
import { useTranslation } from 'react-i18next';
import React from 'react';

export type AttachmentInfoProps = Omit<AlertProps, 'children'> & {
  attachments: ExtAttachmentType[];
  children?: React.ReactNode;
};

/**
 * AttachmentInfo component
 *
 * @param attachments - list of attachments
 * @param children - optional children
 * @param alertProps - additional props for the Alert component
 */
export const AttachmentInfo: React.FC<AttachmentInfoProps> = ({
  attachments,
  children,
  ...alertProps
}) => {
  const { t } = useTranslation(['forms']);

  return (
    <Alert
      title={t('external.attachmentInfo.title')}
      color="blue"
      {...alertProps}
    >
      <Stack spacing="md">
        <Text>
          {t('external.attachmentInfo.content', {
            files: attachments.map(a => a.name).join(', '),
          })}
        </Text>
        {children}
      </Stack>
    </Alert>
  );
};
